<template>
  <div class="hero-header" :class="compact ? 'hero-header--compact' : ''">
    <div class="hero-header__inner">
      <div class="hero-header__left">
        <span v-if="back" class="hero-header__back" @click="$emit('back')">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="15 18 9 12 15 6"/>
          </svg>
        </span>
        <div>
          <div class="hero-header__eyebrow">{{ eyebrow }}</div>
          <h1 class="hero-header__title">{{ title }}</h1>
          <div v-if="counterNum !== null && !compact" class="hero-header__counter">
            <span class="hero-header__counter-num">{{ counterNum }}</span>
            <span v-if="counterUnit" class="hero-header__counter-unit">{{ counterUnit }}</span>
          </div>
        </div>
      </div>
      <div class="hero-header__toolbar">
        <slot name="toolbar"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeroHeader',
  props: {
    eyebrow: { type: String, required: true },
    title: { type: String, required: true },
    counterNum: { type: [String, Number], default: null },
    counterUnit: { type: String, default: '' },
    back: { type: Boolean, default: false },
    compact: { type: Boolean, default: false }
  },
  emits: ['back']
}
</script>
